import { runInAction } from 'mobx'

import BaseStore from './BaseStore'

let state
export class Lang extends BaseStore {
  constructor() {
    super()
    this.observable({
      selected: 'th',
    })
    state = this
  }

  setLanguage(val) {
    const lang = val === 'en' ? 'en' : 'th'
    runInAction(() => {
      state.selected = lang
    })
  }

  getMsg(eng, thai) {
    let text = this.toJS().selected === 'th' ? thai : eng
    if (text === '' || text === undefined) {
      return eng
    }

    return text
  }
}

export default new Lang()
